import { render, staticRenderFns } from "./HotelsMap.vue?vue&type=template&id=5a4b5a75&scoped=true&"
import script from "./HotelsMap.vue?vue&type=script&lang=js&"
export * from "./HotelsMap.vue?vue&type=script&lang=js&"
import style0 from "./HotelsMap.vue?vue&type=style&index=0&id=5a4b5a75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b5a75",
  null
  
)

export default component.exports